import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxDisabled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 24",
	stroke: "var(--control-disabled-border, #CFD4D5)",
	fill: "var(--control-disabled-bg, #E8EAEB)",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: .5,
		width: 23,
		height: 23,
		rx: "var(--checkbox-radius, 7.5)",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckboxDisabled;
